import React, { useState, useEffect } from 'react';
import axios from "axios";
import PAYLATER from "assets/images/payLater.png";
import { Form, FormGroup, Popover, PopoverBody, Button } from "reactstrap";
import {
  callSetPaymentAPI,
  callCardMetaDataAPI,
  callGetTxnStatus
} from "actions/payment";
import { PhoneNumber, DisplayPayBtnText,DisplayConvFee,GoBack } from "components/Common";
import { connect } from "react-redux";
import OTPModal from "components/FDModal/paylater-otp";
import GlobalError from "components/FDModal/global-error";
import GlobalLoaderModal from "components/FDModal/global-loader";
import { RenderForm } from 'components/Common';
import FDConfig from 'lib/config';
import { disableAllPaymentView } from 'actions/payment';

function PaylaterWidget(props) {
  const { t } = props;
  const [phoneNumber, setPhoneNumber] = useState(false);
  const [phoneNumberError, setPhoneError] = useState(false);
  const [transactionMetaData , setTransactionMetaData] = useState(false);
  const [apiError, setApiError] = useState("");
  const [loading, setLoading] = useState(false);
  const [accountDetails, setAccountDetails] = useState({});
  const [phoneNumberEligible, setPhoneEligible] = useState(false);
  const [validAccount, setValidAccount] = useState(false);
  const [accountEligible, setAccountEligibility] = useState(true);
  const [selfOTPBin, setSelfOTP] = useState(false);
  const [verifyOTPSuccess, setVerifyOTPSuccess] = useState(false);
  const [transResp, setTransResp] = useState({});
  const [verifyOTPFailure, setVerifyOTPFailure] = useState(false);
  const [enableResend , setResend]=useState(true);
  const [cardMetaData,setCardMetaData]= useState({});
  // useEffect (() => {
   
  //   // console.log("phoneNumber",phoneNumber)
  //   if(verifyOTPSuccess){
  //       console.log("VERIFYOTP SUCCESS",verifyOTPSuccess);

  //   }

  // })

  const getCompleteDataAndAcountDiscovery = async e => {
    e.preventDefault();
    if (!phoneNumberError && phoneNumber && transactionMetaData) {
      try {
        setLoading(true);
        
        const accountDiscovery = await accountDiscovryICICPayLater();

        setAccountDetails(accountDiscovery);
        setPhoneEligible(true);
        setValidAccount(true);
        props.disableAllPaymentView(true);
      } catch (error) {
        setApiError(error.message);
        return false;
      } finally {
        setLoading(false);
      }
    }
  };

  const getCompleteMetaDataICICPayLater = async () => {
    setApiError("");
    const {
      data: { response }
    } = await callCardMetaDataAPI("ICICIPayLater", phoneNumber);
    // if(Object.entries(response).length  <= 0 ){
    //   throw new Error("Server Error");
    // }
    if (response.errorCode && response.errorCode !== "" && response.errorCode !== "000" && response.transactionStatus != "SUCCESS") {
      throw new Error(response.errorMessage);
    }
    return response;
  };

  const accountDiscovryICICPayLater = async () => {
    const ObjData = {
      mobileNumber: phoneNumber,
      "payLaterAction":"accountDiscovery"
    };
    const { txnKey, txnIv } = props;
    // const {data:{response}}  = await callSetPaymentAPI("ICICIPayLater",ObjData,txnKey ,txnIv);
    setApiError("");
    const data = await callSetPaymentAPI(
      "ICICIPayLater",
      ObjData,
      txnKey,
      txnIv
    );
    const response = data.data;
    if (response.errorCode && response.errorCode !== "" && response.errorCode !== "000" && response.transactionStatus != "SUCCESS") {
      throw new Error(response.errorMessage);
    }
    return response;
  };

  const resendOTP =  ()  => {
    setResend(false);
    accountCheck();
  }

  const accountCheck = async () => {
    try {
      setLoading(true);
      setSelfOTP(false);
      setApiError("");
      const balanceEnquiry = await balanceEnquiryICICIPaylater();
     //  const createOTPICICI = await createOTPICICIPaylater();
      setSelfOTP(true);
    } catch (error) {
      // setSelfOTP(true);
      setApiError(error);
      setAccountEligibility(false);
      setVerifyOTPFailure(true);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const balanceEnquiryICICIPaylater = async () => {
    const { accountNumber } = accountDetails;
    if(accountNumber) {
      const ObjData = {
        accountNo: accountNumber,
        "payLaterAction":"balanceEnquiry"
      };
      const { txnKey, txnIv } = props;
      // const {data:{response}}  = await callSetPaymentAPI("ICICIPayLater",ObjData,txnKey ,txnIv);
      setApiError("");
      const data = await callSetPaymentAPI(
        "ICICIPayLater",
        ObjData,
        txnKey,
        txnIv
      );
      const response = data.data;
      if (response.errorCode && response.errorCode !== "" && response.errorCode !== "000" && response.transactionStatus != "SUCCESS") {
        setTransResp(response);
        throw new Error(response.message);
      } 
      return response;
    }else{
      throw new Error({message:"Not eliglible"});
    }

  };

  // const createOTPICICIPaylater = async () => {
  //   const {
  //     getTxnStatusRequestBean: { fpTransactionId }
  //   } = accountDetails;
  //   const { accountNumber } = accountDetails;
  //   const { transactionDetails } = props;
  //   const { txnKey, txnIv } = props;
  //   const ObjData = {
  //     fpTransactionId,
  //     mobileNumber: phoneNumber,
  //     amount: transactionDetails.amount,
  //     accountNumber,
  //     "payLaterAction":"createOtp"
  //   };
  //   // const {data:{response}}  = await callSetPaymentAPI("CREATEOTP",ObjData,txnKey ,txnIv);
  //   const data = await callSetPaymentAPI("CREATEOTP", ObjData, txnKey, txnIv);
  //   const response = data.data;
  //   if (response.errorCode && response.errorCode !== "") {
  //     throw new Error(response.errorMessage);
  //   } else {
  //     return response;
  //   }
  // };

  const handleChange = async event => {
    // this.setState({value: event.target.value});
    setApiError("");
    let { transactionDetails } = props; 
    var phonenoRegx = /^\(?([0-9]{3})\)?([0-9]{3})[-. ]?([0-9]{4})$/;
    const phoneNo = event.target.value;
    setPhoneNumber(event.target.value);
    if (!phoneNo.match(phonenoRegx)) {
      setPhoneError(true);
      setTransactionMetaData(false);
    } else {
      setPhoneError(false);
      const response  = await getCompleteMetaDataICICPayLater();
      if(response && response.convFee){
        // setPhoneError(false);
        setCardMetaData(response);
        setTransactionMetaData(true);
      }
      
    }
  };

  const onFocusPhoneNumber = event => {
    setApiError("");
  }

  const onCloseOtp = event => {
    // console.log("FKJ");
    setTransResp({transactionStatus:"FAILED",errorCode: "FPDR5029",errorMessage: "Server Error"})
    setVerifyOTPFailure(true);
    setAccountDetails({});
    setPhoneEligible(false);
    setValidAccount(false);
    setPhoneNumber(false);
    setSelfOTP(false);
    setLoading(true);
  }
  const verifyOTP = async otp => {
    try {
      // const {
      //   getTxnStatusRequestBean: { fpTransactionId }
      // } = accountDetails;
      const { accountNumber } = accountDetails;
      const { transactionDetails } = props;
      const { txnKey, txnIv , t  } = props;
      const ObjData = {
//        fpTransactionId,
        mobileNumber: phoneNumber,
        otp,
        // amount: transactionDetails.amount,
       accountNo:accountNumber,
        "payLaterAction":"verifyOtpAndDebit"
      };
      setLoading(true);
      // const {data:{response}}  = await callSetPaymentAPI("CREATEOTP",ObjData,txnKey ,txnIv);
      const data = await callSetPaymentAPI("VERIFYOTP", ObjData, txnKey, txnIv);
      const response = data.data;
      
      if (response.transactionStatus === "failed" || (response.errorCode && response.errorCode !== "" && response.errorCode !== "000" && response.transactionStatus != "SUCCESS")) {
        setAccountDetails({});
        setPhoneEligible(false);
        setValidAccount(false);
        setPhoneNumber(false);
        setSelfOTP(false);
        setLoading(false);
        setApiError(response.errorMessage || "Invalid OTP");
        setTransResp(response);
        setVerifyOTPFailure(true);
        // throw new Error(response.errorMessage);
      } else {
        setTransResp(response);
        setSelfOTP(false);
        setVerifyOTPSuccess(true);
        return response;
      }
    } catch (error) {
      setApiError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="paylater-pannel">
      <div className="flex-column row align-items-center mb-5">
        <img
          src={PAYLATER}
          alt="paylater"
          width="200"
          className="mt-5 mx-auto"
        />
      </div>
      {verifyOTPSuccess && (
        <div>
           <div>OTP verified Redirecting to Merchant Page!</div>
           <RenderForm className='hidden' sessionID = {props.SessionToken}
      nbRespURL={FDConfig.paylater_success} formName="PAYLATER" payLaterRespData={transResp} />
        </div>
       
      )}
       {verifyOTPFailure && (
        <div>
          
           <RenderForm className='hidden' sessionID = {props.SessionToken}
      nbRespURL={FDConfig.paylater_failure} formName="PAYLATER" payLaterRespData={transResp} />
        </div>
       
      )}
      {loading &&  <GlobalLoaderModal></GlobalLoaderModal>}
      {!phoneNumberEligible && !loading && (
        <div className="row paylater-details-panel d-flex justify-content-center">
          <p className=" mx-auto text-14 ">{t("pay-later-mobile")}</p>
          <Form
            onSubmit={getCompleteDataAndAcountDiscovery}
            className="w-100"
            name="phoneForm"
            autoComplete="off"
          >
            <div className="form-group">
              <div className="row">
                {/* <span className="col-md-1 mt-3">+91- </span> */}
                <input
                  value={phoneNumber}
                  onFocus = {onFocusPhoneNumber}
                  onChange={handleChange}
                  className="col-md-11 mx-auto form-control mb-3"
                  type="number"
                  placeholder="Enter phone number"
                />
              </div>

              {!verifyOTPFailure && apiError && (
                <GlobalError errorMessage={apiError} /> 
                // <p className="error text-center">
                //   <span className="d-block">{apiError}</span>
                // </p>
              )}
              {phoneNumberError && (
                <p className="error text-center">
                  <span className="d-block">
                  {t('paylater_mobilenumber_valid_error')}  
                  </span>
                  <br></br>
                  <span className="mt-3 d-block">
                    {" "}
                   {t("paylater_choose_another_paymentMethod")}
                  </span>
                </p>
              )}
              {/* {(transactionMetaData && (
                 <p className="error text-center">
                   <span className="d-block">
                     Transaction completeMeta API Error 
                   </span>
                 </p>
              ))} */}
              <Button
                onClick={getCompleteDataAndAcountDiscovery}
                disabled={phoneNumberError || !phoneNumber || !transactionMetaData || !props.termsStatus}
                className="btn text-center "
              >
                proceed
              </Button>
            </div>
          </Form>
        </div>
      )}

      {!verifyOTPSuccess && validAccount && !loading && (
        <div className="text-center">
          <p className=" mx-auto text-20 ">
          {t('paylater_account_eligible')}
          </p>
          {!accountEligible && (
            <span className="error">
              {t("paylater_account_not_eligible")}
            </span>
          )}
          {apiError && (
            // <GlobalError errMsg={apiError} /> 
            <p className="error text-center">
              <span className="d-block">{apiError}</span>
            </p>
          )}
          <div className="text-left">
            <DisplayConvFee cardMetaData={cardMetaData} t={t}/>
          </div>
          <Button
            type="submit"
            onClick={accountCheck}
            disabled={!accountEligible || loading}
            className="btn mt-5"
          >
            <DisplayPayBtnText
              labelName="Pay"
              cardMetaData={cardMetaData}
              transactionDetails={props.transactionDetails}
              t={props.t}
            />
          </Button>
        </div>
      )}

      {selfOTPBin && (
        <OTPModal submitOTP={verifyOTP} loading= {loading}  closeSelfOTP = {onCloseOtp} enableResend={enableResend} resendOTP={resendOTP} />
      )}
      <div className="go-back-site text-center">
            <GoBack t={t}/>
      </div>
    </div>
  );
}

const mapStateToProps = state => {
  // defaultSelectedPayment
  // console.log("STATE.FDData",state.fdData.defaultSelectedPayment)
  const {termsStatus, transactionDetails, txnKey, txnIv ,SessionToken } = state.fdData;
  let returnProps = {termsStatus, transactionDetails, txnKey, txnIv , SessionToken };
  return { ...returnProps };
};

export default connect(mapStateToProps, {disableAllPaymentView})(PaylaterWidget);
// export default PaylaterWidget;
